/* ============================================================================
   SEGUROS-PLANES · el marco de una pantalla de nivel ruta.

   POR QUÉ EXISTE: la barra superior del tema es `position: fixed` con 70px de
   alto, y quien despeja ese hueco es `.page-content` (padding-top de 70+20px)
   dentro de un `.container-fluid` que pone los márgenes laterales. Una pantalla
   que devuelve un `<section>` pelado se mete DEBAJO del topbar en cuanto hay
   scroll -- que es exactamente lo que pasaba aquí.

   Lo hacen igual Pacientes, Clientes, Configuración y los Reportes, cada uno
   repitiendo los dos divs a mano. Aquí se envuelve una vez para que las tres
   pantallas del módulo no puedan olvidarlo por separado.

   Sólo lo usan las pantallas que cuelgan directamente de una <Route>: la lista
   de aseguradoras, la ficha y el constructor. Las pestañas se pintan DENTRO de
   la ficha, así que ya vienen enmarcadas -- si lo pusieran otra vez, el hueco
   se sumaría dos veces.
   ========================================================================== */

export default function Pagina({ children, className, ...resto }) {
    return (
        <div className="page-content">
            <div className="container-fluid">
                <section className={className} {...resto}>
                    {children}
                </section>
            </div>
        </div>
    );
}
